import {
  GeoCircle,
  isValidLatLng,
  isValidRange,
} from '~/utility/geo/GeoLocation'
import { SearchFilters } from '../../search/schemas'

interface QueryPart {
  lat?: string
  lng?: string
  within: number
}

export function toQuery({ area, within }: SearchFilters): QueryPart | {} {
  // If no area, only return within if explicitly set
  if (!area) {
    return within ? { within } : {}
  }

  const { lat, lng } = area

  // If we have an empty point, only return within if explicitly set
  if (area.isEmptyPoint) {
    return within ? { within } : {}
  }

  // For points with coordinates, only include within if explicitly set
  return {
    lat,
    lng,
    ...(within ? { within } : {}),
  }
}

export function fromQuery(query: Partial<QueryPart>): { area?: GeoCircle } {
  if (query.lat && query.lng) {
    const point = {
      lat: Number(query.lat),
      lng: Number(query.lng),
      isEmptyPoint: false,
    }

    // If we have a valid lat/lng but no within, just return the point without rangeMiles
    if (!query.within && isValidLatLng({ lat: point.lat, lng: point.lng })) {
      return {
        area: {
          ...point,
          rangeMiles: undefined,
        },
      }
    }

    // If we have within, validate both point and range
    const range = query.within ? Number(query.within) : undefined
    if (
      range &&
      isValidLatLng({ lat: point.lat, lng: point.lng }) &&
      isValidRange(range)
    ) {
      return {
        area: {
          ...point,
          rangeMiles: range,
        },
      }
    }
  } else if (query.within && !isNaN(query.within)) {
    return {
      area: {
        lat: 0,
        lng: 0,
        isEmptyPoint: true,
        rangeMiles: Number(query.within),
      },
    }
  }
  return {}
}
